import YandexMap from "./../event/yandexMap";
import Notify from "./../notify";
import Litepicker from "./../litepicker";

$(function() {

    let map = new YandexMap("location-map", "addres");
    map.run();



    // Locations 
    var ajaxLinkLocation = "/themes/ahtilahti/ajax/locations/handler.php";
    var submitFormLocationCreate = "#create-arend-location";
    var submitFormLocationEdit = "#edit-arend-location";




    function submitLocationForm(form, action = null) {
        if (!action) {
            return false;
        }
        var addres = $("#addres");
        addres.removeAttr("disabled");
        let data = form.serializeArray();

        addres.attr("disabled", "disabled");

        let requiredError = false;
        data.forEach((element) => {
            var el = $("[name=" + element.name + "]");
            var required = el.attr("data-required");

            if (required == "Y") {
                if (!element.value.trim() || element.value.trim().length == 0) {
                    el.addClass("callout alert");
                    requiredError = true;
                } else {
                    el.removeClass("callout alert");
                }
            }
        });

        if (requiredError) {
            new Notify("Пожалуйста, Заполните обязательные поля", "alert");
        } else {
            $.ajax({
                method: "POST",
                url: ajaxLinkLocation,
                data: {
                    action: action,
                    data: {
                        data: data,
                    },
                },
                success: function(response) {
                    let res;
                    typeof response === "string" ?
                        (res = $.parseJSON(response)) :
                        (res = response);
                    if (res.success) {
                        new Notify(res.message, "success");
                        setTimeout(function() {
                            document.location.href = "/arenda/locations/";
                        }, 500)

                    } else {
                        new Notify(res.message, "alert");
                    }
                },
                error(xhr, status, error) {
                    new Notify(error, "alert");
                },
            });
        }
    }

    $(submitFormLocationCreate).on("submit", function(e) {
        e.preventDefault();
        submitLocationForm($(this), "create")
    });

    $(submitFormLocationEdit).on("submit", function(e) {
        e.preventDefault();
        submitLocationForm($(this), "edit")
    });


});